import { SalaryIncreasePlaceholder } from "../components/SalaryIncreasePlaceholder";

export default function AuditTrailPage() {
  return (
    <SalaryIncreasePlaceholder
      title="Audit Trail"
      description="A record of every material action in the increase cycle."
    />
  );
}
